function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
export var toInstanceLog = function toInstanceLog(Weblog) {
  var weblog = new Weblog({
    env: 'production',
    // env: 'logger',

    // 如果要测试雷达数据，需要在 production 环境下
    fps: false,
    crash: false,
    autoPV: true,
    timing: true,
    radar: {
      projectId: '4fa1f3d229',
      // 雷达平台上的唯一标识
      sampling: 1,
      // 上报采样率，1 为全部上报
      unuseErrorPlugin: true
    }
  }, {
    product_name: 'KUAISHOU'
  });
  var sendLogs = {
    /**
     * 页面PV事件
     * @params {
     *     params: { Object } 需要上报的参数集合
     *     page: 代表当前页面的 英文名字
     * }
     * */
    PV: function PV(_ref) {
      var _ref$params = _ref.params,
        params = _ref$params === void 0 ? {} : _ref$params,
        page = _ref.page;
      var logParams = {
        type: "enter",
        params: params
      };
      if (page) {
        logParams.page = page;
      }
      weblog.sendImmediately("PV", _objectSpread({}, logParams));
    },
    /**
     * 元素点击事件
     * @params {
     *     action: { String } 元素英文名
     *     params: { Object } 需要上报的参数集合
     * }
     * */
    CLICK: function CLICK(_ref2) {
      var _ref2$action = _ref2.action,
        action = _ref2$action === void 0 ? "" : _ref2$action,
        _ref2$params = _ref2.params,
        params = _ref2$params === void 0 ? {} : _ref2$params;
      var logParams = {
        action: action,
        params: _objectSpread({}, params)
      };
      weblog.sendImmediately("CLICK", _objectSpread({}, logParams));
    },
    /**
     * 元素曝光事件
     * @params {
     *     action: { String } 元素英文名
     *     params: { Object } 需要上报的参数集合
     * }
     * */
    SHOW: function SHOW(_ref3) {
      var _ref3$action = _ref3.action,
        action = _ref3$action === void 0 ? "" : _ref3$action,
        _ref3$params = _ref3.params,
        params = _ref3$params === void 0 ? {} : _ref3$params;
      var logParams = {
        action: action,
        params: _objectSpread({}, params)
      };
      weblog.sendImmediately("SHOW", _objectSpread({}, logParams));
    }
  };
  return sendLogs;
};